var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100 video-item-container",
    class: _vm.videoContainerClasses
  }, [_c('div', {
    staticClass: "row pb-2 d-flex",
    class: _vm.videoClasses,
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row justify-content-center",
    class: _vm.columnClass
  }, [_c('EmbeddedVideoPlayer', {
    attrs: {
      "videoId": _vm.videoId,
      "videoSource": _vm.videoSrc,
      "videoThumbnail": _vm.videoThumbnail,
      "selectedVideoId": _vm.selectedVideoPlayingId,
      "isMP4Video": _vm.isMP4Video
    },
    on: {
      "video-player-in-progress": _vm.isVideoPlayerPlayer
    }
  })], 1), _c('div', {
    staticClass: "d-flex flex-column mb-0 video-gap-between",
    class: _vm.columnClass
  }, [_c('div', {
    staticClass: "library-item-text video-title w-100 d-flex flex-row justify-content-start mt-1"
  }, [_vm._v(" " + _vm._s(_vm.videoTitle) + " ")]), _c('div', {
    staticClass: "video-description mb-4"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.videoTextDescription)
    }
  })]), _c('div', {
    staticClass: "video-share-button",
    class: {
      'share-button-from-right': !_vm.showShareButtonFromLeft,
      'share-button-from-left': _vm.showShareButtonFromLeft
    },
    attrs: {
      "id": `video-tooltip-${_vm.videoId}`
    },
    on: {
      "click": _vm.toggleCopyVideoUrl
    }
  }, [_c('img', {
    staticClass: "video-share-image",
    attrs: {
      "src": require('../../../assets/images/Share-08.svg'),
      "width": "20px",
      "height": "20px"
    }
  })]), _vm.isDropdownOpen && _vm.videoShare ? _c('CopyUrlClipboard', {
    attrs: {
      "classes": 'share-button-from-left',
      "urlSource": _vm.videoShare,
      "copyHandlerComplete": _vm.afterCopyHandler
    }
  }) : _vm.isDropdownOpen ? _c('CopyUrlClipboard', {
    attrs: {
      "classes": _vm.showShareButtonFromLeft ? 'share-button-from-left' : 'dropdown-content-from-right',
      "urlSource": _vm.videoSrc,
      "copyHandlerComplete": _vm.afterCopyHandler
    }
  }) : _vm._e()], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }